// extracted by mini-css-extract-plugin
export default {"lds-circle":"style_lds-circle__d4IlD"};